import { IDirective, IDocumentService, IScope, ITimeoutService, IWindowService } from 'angular';
import { Observable } from 'rxjs/Observable';
import { throttleTime } from 'rxjs/operators';
import { $Event } from '../../../helpers';
import 'rxjs/add/observable/fromEvent';

export interface IScrollSpyScope extends IScope {
  scrolled: ( val ) => void;
}

export function gmcScollOffsetDirective( $window: IWindowService,
                                         $document: IDocumentService,
                                         $timeout: ITimeoutService ): IDirective {
  return {
    restrict: 'A',
    scope: {
      scrolled: '&'
    },
    link: function postLink( scope: IScrollSpyScope, $element, attrs ) {
      let offset;
      let prevValue = null;
      attrs.$observe('gmcScrollOffset', ( val: string ) => {
        offset = parseInt(val, 10);
      });
      const sub = Observable.fromEvent($window, 'scroll')
        // .pipe(throttleTime(50))
        .subscribe(() => {
          const scrollTop = $window.pageYOffset
            || $document[ 0 ].scrollTop
            || $document[ 0 ].body.scrollTop
            || 0;

          if ( scrollTop > offset && prevValue !== true ) {
            prevValue = true;
            $timeout(() => {
              scope.scrolled(new $Event({ value: true, event }));
            });
          } else if ( scrollTop < offset && prevValue !== false ) {
            prevValue = false;
            $timeout(() => {
              scope.scrolled(new $Event({ value: false, event }));
            });
          }
        });
      scope.$on('$destroy', () => {
        sub.unsubscribe();
      });
    }
  };
}

gmcScollOffsetDirective.$inject = [
  '$window',
  '$document',
  '$timeout'
];



// WEBPACK FOOTER //
// ./app/shared/directives/gmc-scroll-spy/gmc-scroll-offset.directive.ts